module.exports = __webpack_public_path__ + "icon-flag.png?b72b6c56a0d63a735fa5cbd88d26e37f";


//////////////////
// WEBPACK FOOTER
// ./Content/img/icon-flag.png
// module id = 840
// module chunks = 1